import React from 'react';

import { observer } from 'mobx-react';

import { useUsdtValue } from '@widget/airdrop/hooks/useUsdtValue';

interface CalculatedValueProps {
  coinCode: string;
  total: number;
  className?: string;
}

export const CalculatedValue: React.FC<CalculatedValueProps> = observer(({ coinCode, total, className }) => {
  const count = useUsdtValue({ coinCode, count: total });
  return (
    <span className={className}>{count}</span>
  )
})
